import React from "react";
import ProjectChart from "../../../components/common/UseroverviewChart";
import { OverviewTimesheet } from "./OverviewTimesheet";
const UserOverview = ({ userDetails }) => {
  const projectStatuses = userDetails?.dashboard?.project?.statuses || [];
  const taskStatuses = userDetails?.dashboard?.task?.statuses || [];
  const issueStatuses = userDetails?.dashboard?.issue?.statuses || [];
  const mitestoneStatuses = userDetails?.dashboard?.milestone?.statuses || [];
  const timesheetStatuses = userDetails?.timesheet || [];
  // //console.log()(timesheetStatuses, 'timesheetStatuses');
  // //console.log()(userDetails, 'userDetails');
  
  
  return (
    <>
      <div className="container-fluid">
        <div
          className="row px-3 py-3 g-3 mt-4 justify-content-around"
          style={{ background: " var(--cell-bg-color) " }}
        >
          <div
            className="col-md-5 bg-white"
            style={{
              padding: "16px",
              borderRadius: "8px",
              // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 2px 1px',
              // background: "white",
            }}
          >
            <h4>Project</h4>
            <hr />
            <ProjectChart data={projectStatuses} />
          </div>

          <div
            className="col-md-5 bg-white"
            style={{
              padding: "16px",
              borderRadius: "8px",
              // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 2px 1px',
              // background: "white",
            }}
          >
            <h4>Task</h4>
            <hr />
            <ProjectChart data={taskStatuses} />
          </div>
          <div
            className="col-md-5 bg-white"
            style={{
              padding: "16px",
              borderRadius: "8px",
              // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 2px 1px',
              // background: "white",
            }}
          >
            <h4>Issues</h4>
            <hr />
            <ProjectChart data={issueStatuses} />
          </div>

          <div
            className="col-md-5 bg-white"
            style={{
              padding: "16px",
              borderRadius: "8px",
              // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 2px 1px',
              // background: "white",
            }}
          >
            <h4>Milestone</h4>
            <hr />
            <ProjectChart data={mitestoneStatuses} />
          </div>

          <div
            className="col-md-11 bg-white"
            style={{
              padding: "16px",
              borderRadius: "8px",
              // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 2px 1px',
              // background: "white",
            }}
          >
            <h4>Timesheet</h4>
            <hr />
            <OverviewTimesheet timesheetStatuses={timesheetStatuses} />
          </div>
        </div>
      </div>
    </>
  );
};

export default UserOverview;
